import styled from 'styled-components';
import c from '../../utils/constants';

export const P = styled.p`
  color: ${c.primary};
  font-size: 1em;
  padding: 1em;
  text-align: justify;
  border: 2px solid red;
  border-radius: 5px;
`;
export const Root = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 0.5em;
  padding: 1em;
`;
